import { render, staticRenderFns } from "./CustomerTabs.vue?vue&type=template&id=d56f2f18&"
import script from "./CustomerTabs.vue?vue&type=script&lang=js&"
export * from "./CustomerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports